"use client";
import { isBackdrop } from "./is-backdrop.js";
import { assignStyle, orchestrate, setAttribute, setProperty } from "./orchestrate.js";
import { addAncestorMarkCleanup, addElementMarkCleanup, restoreCleanups } from "./tree-cleanup.js";
import { walkTreeOutside } from "./walk-tree-outside.js";
import { hideElementFromAccessibilityTree } from "./disable-accessibility-tree-outside.js";
import { isFocusTrap } from "./is-focus-trap.js";
import { supportsInert } from "./supports-inert.js";
import { chain, contains, getAllTabbableIn, noop } from "@ariakit/utils";
//#region src/dialog/utils/disable-tree.ts
function disableTree(element, ignoredElements) {
	if (!("style" in element)) return noop;
	if (supportsInert()) return setProperty(element, "inert", true);
	return chain(...getAllTabbableIn(element, true).map((element) => {
		if (ignoredElements?.some((el) => el && contains(el, element))) return noop;
		const restoreFocusMethod = orchestrate(element, "focus", () => {
			element.focus = noop;
			return () => {
				delete element.focus;
			};
		});
		return chain(setAttribute(element, "tabindex", "-1"), restoreFocusMethod);
	}), hideElementFromAccessibilityTree(element), assignStyle(element, {
		pointerEvents: "none",
		userSelect: "none",
		cursor: "default"
	}));
}
function addDisabledElementCleanup({ cleanups, element, elements, ids }) {
	if (isBackdrop(element, ...ids)) return;
	if (isFocusTrap(element, ...ids)) return;
	cleanups.push(disableTree(element, elements));
}
function addRoleNoneCleanup(cleanups, ancestor, elements) {
	if (!ancestor.hasAttribute("role")) return;
	if (elements.some((el) => el && contains(el, ancestor))) return;
	cleanups.push(setAttribute(ancestor, "role", "none"));
}
function markAndDisableTreeOutside(id, elements) {
	const cleanups = [];
	const ids = elements.map((el) => el?.id);
	walkTreeOutside(id, elements, (element) => {
		addElementMarkCleanup({
			cleanups,
			element,
			id,
			ids
		});
		addDisabledElementCleanup({
			cleanups,
			element,
			elements,
			ids
		});
	}, (ancestor, element) => {
		addAncestorMarkCleanup({
			cleanups,
			ancestor,
			element,
			id
		});
		addRoleNoneCleanup(cleanups, ancestor, elements);
	});
	const restoreTreeOutside = () => {
		restoreCleanups(cleanups);
	};
	return restoreTreeOutside;
}
//#endregion
export { disableTree, markAndDisableTreeOutside };

//# sourceMappingURL=disable-tree.js.map